import { type ResourceType, resourceTypeEnabledAtom } from "@/modules/api/resourceTypes.tsx";
import { userRoleAtom } from "@/modules/user/userApi.ts";
import { atomFamily } from "jotai-family";
import { atom } from "jotai/vanilla";

// All the menu items and details view blocks that are visible/hidden to admins and used right now.
const adminMenuItems: string[] = [
    "dashboard",
    "users",
    "admin_users",
    "accounts",
    "reports",
    "prices",
    "custom_products",
    "marketing",
    "locations",
    "settings",
];

//#region Type definitions
export type AdminMenuItemType = (typeof adminMenuItems)[number];

//#endregion

export const resourcePrivilegeAtom = atomFamily((resourceType: ResourceType) =>
    atom((get) => {
        if (!get(resourceTypeEnabledAtom(resourceType))) return false;

        const role = get(userRoleAtom).data?.role;
        switch (role) {
            case "admin":
                return true;
            case "admin-accountant":
                return resourceType === "billing_account";
            default:
                return false;
        }
    }),
);

export const menuItemPrivilegeAtom = atomFamily((itemId: AdminMenuItemType) =>
    atom((get) => {
        void itemId; // Currently unused

        const role = get(userRoleAtom).data?.role;
        switch (role) {
            case "admin":
                return true;
            case "admin-accountant":
                return false;
            default:
                return false;
        }
    }),
);
